import { render, staticRenderFns } from "./EmailApprovalPage.vue?vue&type=template&id=305109d4&scoped=true&lang=pug"
import script from "./EmailApprovalPage.vue?vue&type=script&lang=js"
export * from "./EmailApprovalPage.vue?vue&type=script&lang=js"
import style0 from "./EmailApprovalPage.vue?vue&type=style&index=0&id=305109d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305109d4",
  null
  
)

export default component.exports